export function getCurrentPrivacySetting(state) {
    return state.PrivacySettingReducer.privacySetting;
}

export function getOtherPrivacySetting(state) {
    return state.PrivacySettingReducer.otherPrivacySetting;
}
